import { AfterViewChecked, Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { FAZILService, User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { environment } from 'src/environments/environment';
import { ContactosService } from 'src/app/contactos/contactos.service';
import { SubjectCustomer } from '../modelo/SubjectCustomer';
import { Subject } from '../modelo/Subject';

import { AdministracionService } from 'src/app/administracion/administracion.service';
import { validateDni } from 'src/app/shared/helpers';
import { validateRUC } from 'src/app/shared/helpers';
import { validateEmail } from 'src/app/shared/helpers';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FazilController } from '../core/fazil-controller-component';
import { FormBuilder } from '@angular/forms';
import { SubjectCustomerOutput } from '../core/models/contacto.model';
import { Subscription } from 'rxjs';
import { Subject as SubjectRXJS } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-contacto-buscador',
    templateUrl: './contacto-buscador.component.html',
    styleUrls: ['./contactos.component.scss']
})
export class ContactoBuscadorComponent  extends FazilController  implements OnInit, AfterViewChecked, OnChanges {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    _customer: Subject = new Subject();
    
    //Variables auxiliares
    cargandoDataInit: boolean = false;
    procesando: boolean = false;

    _mostrarBuscador: boolean = false;
    
    _mostrarEditor: boolean = false;
    
    @Output() contactoSeleccionado = new EventEmitter<SubjectCustomerOutput>();
    
    @Input() estaCargandoDatos: boolean = false;
    
    subjectCustomer: SubjectCustomer = new SubjectCustomer();
    subjectCustomersFiltered:SubjectCustomer[] = [];
    processFilter:boolean = false;
    
    filterDebounceTime: number = 500;
    filterTextChanged: SubjectRXJS<any> = new SubjectRXJS<any>();
    
    visible:boolean = false;

    constructor(
        private zone: NgZone,
        private router: Router,
        private route: ActivatedRoute,
        private fazilService: FAZILService,
        private confirmationService: ConfirmationService,
        private contactosService: ContactosService,
        private sanitizer: DomSanitizer,
        public override uiService: UIService,
        public override messageService: MessageService,
        public override administracionService: AdministracionService,
        public override _formBuilder: FormBuilder
    ) {
        super(uiService, messageService, administracionService, _formBuilder);
    }
    
    ngOnChanges(_changes: SimpleChanges): void {
        this.visible = this.mostrarBuscador;
    }
    
    ngOnInit(): void {
        if (!this.estaCargandoDatos) {
            this.zone.runOutsideAngular(() => this.initComponent())
        }
    }
    
    ngAfterViewChecked(): void {
        //dummy
    }
    
    //Detecta los cambios desde fuera del componente
//    ngOnChanges(changes: SimpleChanges): void {
//        //TODO Entender para que es
//        //throw new Error('Method not implemented.');
//    }
//    
    async initComponent() {
        this.estaCargandoDatos = false;
        this.resetVariablesSubjects();
    }
    
    @Input() 
    set mostrarBuscador(v){
        this._mostrarBuscador = v;
    }
    
    get mostrarBuscador(){
        return this._mostrarBuscador;
    }
    
    @Input() 
    set mostrarEditor(v){
        this._mostrarEditor = v;
    }
    
    get mostrarEditor(){
        return this._mostrarEditor;
    }
    
    async filteredSubjectCustomerByKeyword($event: any) {
        if (this.filterTextChanged.observers.length === 0) {
            this.filterTextChanged.pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged()).subscribe(async query => {
                if (query.$event.target.value.length > 2) {
                    this.processFilter = true;
                    const keyword = query.$event.target.value.toLocaleLowerCase();
                    this.pageOptions = { page: 0, pageSize: 999, filter: keyword, orderBy: 'name', order: 'ASC' };
                    const page = await this.contactosService.getContactosPorUsuarioConectadoData(this.pageOptions);
                    this.subjectCustomersFiltered = page['content'];
                }
            });
        }
        this.filterTextChanged.next({ $event });
    }
    
    resetVariablesSubjects(): void {
        this.ui.limpiarMessages();
        this.subjectCustomer = new SubjectCustomer();//Objeto principal de edición
        this.subjectCustomer.customer = new Subject(); //Inicializa objeto auxiliar
    }

    nuevoContacto() {
        this.resetVariablesSubjects();
        this.mostrarEditor = true;
    }
    
    
    seleccionarContacto(event, item: SubjectCustomer, facturarSoloCedula:boolean){
        const mode = facturarSoloCedula ? "cedula" : "ruc";
        this.contactoSeleccionado.emit({
            data: item,
            success: (item != null),
            message: '¡Contacto seleccionado!',
            mode: mode
        });
        this.cerrarPopup(true);
    }
    
    cerrarPopup(seleccionado:boolean){
        this.visible = false;
        if (!seleccionado){
            this.seleccionarContacto(null, null, false);
        }
    }
    
    handleContactoGuardado(subjectCustomerOutput:SubjectCustomerOutput){
        if (subjectCustomerOutput.success){
            const esCedula:boolean = subjectCustomerOutput.data.customerCode.length == 10;
            this.seleccionarContacto(null, subjectCustomerOutput.data, esCedula);
        }   
    }
    
    @Input()
    public set currentUser(currentUser: User) {
        this._currentUser = currentUser
    }

    public get currentUser() { return this._currentUser; }
}
